










import Loader from '@/components/Loader.vue';
import Translation from '@/components/i18n/Translation.vue';
import Button from '@/components/Button.vue';
import TabBar from '@/components/TabBar.vue';
import NavBar from '@/components/NavBar.vue';
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import CheckoutApi from '@/app/api/CheckoutApi';
import { namespace } from 'vuex-class';

const I18nModule = namespace('i18n');

@Component({
  components: {
    NavBar,
    TabBar,
    Button,
    Translation,
    Loader,
  },
})
export default class CheckoutPaymentDetailsView extends Vue {
  @Prop(Array)
  private lang!: Array<{ [key: string]: string }>;

  @Ref('content') readonly contentDiv!: HTMLElement;

  @I18nModule.Getter
  private readonly locale!: string;

  public async mounted() {
    const orderId1 = this.orderId;
    const paymentMethod1 = this.paymentMethod;
    if (orderId1 && paymentMethod1) {
      const content = await CheckoutApi.getPaymentEntryPage(orderId1, paymentMethod1, this.locale);
      this.contentDiv.innerHTML = content;
      return;
    }
    // @ts-ignore
    window.wpwlOptions = {
      locale: 'de',
    };

    const script = document.createElement('script');
    script.setAttribute('src', `${this.paymentUrl}/v1/paymentWidgets.js?checkoutId=${this.checkoutId}`);
    script.setAttribute('id', 'vr-payment-widget-script');
    document.head.appendChild(script);
  }

  public get checkoutId() {
    return this.$route.query.checkoutId || null;
  }
  public get paymentUrl() {
    return this.$route.query.paymentUrl || null;
  }
  public get orderId(): string | null {
    return (this.$route.query.orderId as string) || null;
  }
  public get paymentMethod(): string | null {
    return (this.$route.query.paymentMethod as string) || null;
  }

  public beforeDestroy(): void {
    const elementById = document.getElementById('vr-payment-widget-script');
    if (elementById) {
      elementById.remove();
    }

    // @ts-ignore
    delete window.wpwlOptions;
  }

  public get shopperReturnUrl(): string {
    return `${window.location.origin}/${this.$route.params.communeId}/checkout/payment/verify?orderId=${this.orderId}&paymentMethod=${this.paymentMethod}`;
  }
}
